import type { FC } from 'react';
import { Button, type ButtonType } from '~/components/Button';

import CheckBox from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank';
import Code from '@mui/icons-material/Code';
import { Tooltip } from '@mui/material';

interface SnippetsButtonProps extends ButtonType {
  showSnippets: boolean;
  setShowSnippets: (showSnippets: boolean) => void;
}

const SnippetsButton: FC<SnippetsButtonProps> = ({
  showSnippets,
  setShowSnippets,
  ...rest
}) => {
  return (
    <Button
      onClick={() => setShowSnippets(!showSnippets)}
      startIcon={showSnippets ? <CheckBox /> : <CheckBoxOutlineBlank />}
      endIcon={<Code fontSize="small" color="disabled" />}
      {...rest}>
      <Tooltip
        title={showSnippets ? 'Hide Code Snippets' : 'Show Code Snippets'}>
        <span>Code Snippets</span>
      </Tooltip>
    </Button>
  );
};

export default SnippetsButton;
